// Generated by `yarn generate:permissions-catalog` in the backend repo.
// Do not edit by hand.

export const PERMISSIONS: readonly string[] = [
	'AgentChat.agentChats',
	'AgentChat.createAgentChat',
	'AgentChat.delete',
	'AgentChat.update',
	'AgentChat.view',
	'AgentChat.viewUsage',
	'AIChat.promptFeedbackTips',
	'AIChat.startAIGeneratedCompetenciesChat',
	'AIChat.startAIGeneratedGoalChat',
	'AIChat.view',
	'AINotesSummary.prompt',
	'AINoteTemplateTalkingPoints.prompt',
	'Analytics.all',
	'Analytics.departmentGoalMetricGroup',
	'Analytics.engagement',
	'Analytics.group',
	'Analytics.groups',
	'Analytics.metricDetail',
	'Analytics.workspace',
	'Announcement.announcement',
	'Announcement.announcements',
	'Announcement.markAnnouncementAsRead',
	'Announcement.markAnnouncementAsUnread',
	'ApiTokens.manageApiTokens',
	'Asset.asset',
	'Asset.create',
	'Asset.view',
	'Asset.viewMany',
	'Career.archive',
	'Career.create',
	'Career.update',
	'Career.viewAll',
	'Checkpoint.updateWorkspaceCheckpoints',
	'Checkpoint.viewWorkspaceCheckpoints',
	'Comment.archive',
	'Comment.create',
	'Comment.createComment',
	'Comment.restore',
	'Comment.update',
	'Comment.viewAll',
	'Competency.archive',
	'Competency.attachToGoal',
	'Competency.create',
	'Competency.update',
	'Competency.view',
	'Competency.viewAll',
	'Competency.viewAppraisals',
	'Competency.viewAppraisalsForGoalCompetency',
	'CompetencyBookmark.archive',
	'CompetencyBookmark.create',
	'CompetencyBookmark.restore',
	'CompetencyBookmark.update',
	'CompetencyBookmark.viewAll',
	'CompetencyLevelSet.archive',
	'CompetencyLevelSet.create',
	'CompetencyLevelSet.update',
	'CompetencyLevelSet.view',
	'CompetencyLevelSet.viewAll',
	'Compliment.archive',
	'Compliment.view',
	'Compliment.viewAll',
	'Connector.connectors',
	'Connector.queue',
	'Connector.update',
	'Connector.view',
	'ConnectorLog.store',
	'ConnectorLog.viewAll',
	'ConnectorUpload.viewAll',
	'CustomEmailDomain.view',
	'CycleInstance.create',
	'CycleInstance.cycleInstancesForProcessing',
	'CycleInstance.processCycleInstance',
	'CycleInstance.remove',
	'CycleInstance.skipFuture',
	'CycleInstance.update',
	'CycleInstance.view',
	'CycleInstance.viewUser',
	'CycleTemplate.archive',
	'CycleTemplate.create',
	'CycleTemplate.update',
	'CycleTemplate.view',
	'CycleTemplate.viewAll',
	'EngagementCategory.archive',
	'EngagementCategory.create',
	'EngagementCategory.restore',
	'EngagementCategory.update',
	'EngagementCategory.view',
	'EngagementCategory.viewAll',
	'EngagementQuestion.archive',
	'EngagementQuestion.create',
	'EngagementQuestion.reorder',
	'EngagementQuestion.restore',
	'EngagementQuestion.update',
	'EngagementQuestion.view',
	'EngagementQuestion.viewAll',
	'EngagementReply.assertOwnership',
	'EngagementReply.create',
	'EngagementReply.view',
	'EngagementRequest.cancel',
	'EngagementRequest.sendReminders',
	'EngagementRequest.view',
	'EngagementRequest.viewAll',
	'EngagementRequestListing.viewListing',
	'EngagementResponse.update',
	'EngagementResponse.view',
	'EngagementSettings.update',
	'EngagementSettings.viewAll',
	'EngagementSubcategory.archive',
	'EngagementSubcategory.create',
	'EngagementSubcategory.reorder',
	'EngagementSubcategory.restore',
	'EngagementSubcategory.update',
	'EngagementSubcategory.view',
	'EngagementTemplate.update',
	'EngagementTemplate.view',
	'EngagementTemplate.viewAll',
	'EngagementTemplateListing.viewListing',
	'EngagementType.view',
	'EngagementType.viewAll',
	'EvaluationForm.archive',
	'EvaluationForm.create',
	'EvaluationForm.update',
	'EvaluationForm.view',
	'EvaluationForm.viewAll',
	'EvaluationSubmission.archive',
	'EvaluationSubmission.changeConversationPartner',
	'EvaluationSubmission.complete',
	'EvaluationSubmission.conversationsTwoWayReady',
	'EvaluationSubmission.create',
	'EvaluationSubmission.createComment',
	'EvaluationSubmission.discardAnswersFromPredecessor',
	'EvaluationSubmission.overrideScore',
	'EvaluationSubmission.reschedule',
	'EvaluationSubmission.share',
	'EvaluationSubmission.sign',
	'EvaluationSubmission.unsign',
	'EvaluationSubmission.update',
	'EvaluationSubmission.updateAsEmployee',
	'EvaluationSubmission.updateAsManager',
	'EvaluationSubmission.updateMeetingStatus',
	'EvaluationSubmission.view',
	'EvaluationSubmission.viewAll',
	'EvaluationSubmission.viewAsEmployee',
	'EvaluationSubmission.viewAsManager',
	'EvaluationSubmission.viewComments',
	'Expertise.archive',
	'Expertise.create',
	'Expertise.update',
	'Expertise.viewAll',
	'FailedSsoAttempt.viewAll',
	'FeatureRatings.create',
	'FeatureRatings.update',
	'FeatureRatings.view',
	'FeedbackQuestion.archive',
	'FeedbackQuestion.create',
	'FeedbackQuestion.restore',
	'FeedbackQuestion.update',
	'FeedbackQuestion.view',
	'FeedbackQuestion.viewAll',
	'FeedbackQuestionCategory.archive',
	'FeedbackQuestionCategory.create',
	'FeedbackQuestionCategory.restore',
	'FeedbackQuestionCategory.update',
	'FeedbackQuestionCategory.view',
	'FeedbackQuestionCategory.viewAll',
	'FeedbackRequest.archive',
	'FeedbackRequest.create',
	'FeedbackRequest.restore',
	'FeedbackRequest.send',
	'FeedbackRequest.share',
	'FeedbackRequest.view',
	'FeedbackRequest.viewAll',
	'FeedbackResponse.archive',
	'FeedbackResponse.createComment',
	'FeedbackResponse.external',
	'FeedbackResponse.externalKakapoFeedback',
	'FeedbackResponse.internal',
	'FeedbackResponse.internalKakapoFeedback',
	'FeedbackResponse.restore',
	'FeedbackResponse.update',
	'FeedbackResponse.view',
	'FeedbackResponse.viewComments',
	'FeedbackResponse.viewSharedAnswersBeforeRelease',
	'FeedbackTemplate.archive',
	'FeedbackTemplate.create',
	'FeedbackTemplate.restore',
	'FeedbackTemplate.update',
	'FeedbackTemplate.view',
	'FeedbackTemplate.viewAll',
	'Goal.archive',
	'Goal.create',
	'Goal.createComment',
	'Goal.restore',
	'Goal.update',
	'Goal.view',
	'Goal.viewArchived',
	'Goal.viewAuditTrail',
	'Goal.viewChildren',
	'Goal.viewComments',
	'Goal.viewGroupGoals',
	'Goal.viewRevision',
	'Goal.viewUserGoals',
	'Goal.viewWorkspaceGoals',
	'GoalDriver.archive',
	'GoalDriver.create',
	'GoalDriver.goalDrivers',
	'GoalDriver.restore',
	'GoalDriver.update',
	'GoalTemplate.archive',
	'GoalTemplate.create',
	'GoalTemplate.update',
	'GoalTemplate.view',
	'GoalTemplate.viewAll',
	'GoodHabitz.updateConfig',
	'GoodHabitz.viewConfig',
	'Group.archive',
	'Group.create',
	'Group.group',
	'Group.groups',
	'Group.groupsByExternalReferenceID',
	'Group.manage',
	'Group.move',
	'Group.restore',
	'Group.update',
	'Group.view',
	'IdentityProvider.create',
	'IdentityProvider.delete',
	'IdentityProvider.queryByDomain',
	'IdentityProvider.singleSignOns',
	'IdentityProvider.update',
	'IdentityProvider.viewAll',
	'InboxTask.archive',
	'InboxTask.mark',
	'InboxTask.restore',
	'JobCompetency.attach',
	'JobCompetency.detach',
	'JobGoalTemplate.attach',
	'JobGoalTemplate.detach',
	'JobGoalTemplate.update',
	'JobLevel.archive',
	'JobLevel.create',
	'JobLevel.update',
	'JobLevel.view',
	'JobLevel.viewAll',
	'JobPosition.archive',
	'JobPosition.assumeJobTitle',
	'JobPosition.create',
	'JobPosition.jobPosition',
	'JobPosition.update',
	'JobPosition.view',
	'JobPosition.viewAll',
	'JobPosition.viewForUser',
	'JobPositionSuccessor.archive',
	'JobPositionSuccessor.nominate',
	'JobPositionSuccessor.update',
	'JobPositionSuccessor.viewForJobTitle',
	'JobTitle.archive',
	'JobTitle.create',
	'JobTitle.manageSuccession',
	'JobTitle.update',
	'JobTitle.view',
	'JobTitle.viewAll',
	'Label.archive',
	'Label.create',
	'Label.update',
	'Label.view',
	'Label.viewAll',
	'LearningCourse.view',
	'LearningCourse.viewAll',
	'LearningEvent.archive',
	'LearningEvent.cancel',
	'LearningEvent.create',
	'LearningEvent.join',
	'LearningEvent.leave',
	'LearningEvent.review',
	'LearningEvent.update',
	'LearningEvent.view',
	'LearningEvent.viewAll',
	'LearningEvent.viewProposals',
	'LearningEvent.viewUserProposals',
	'LearningSubject.archive',
	'LearningSubject.create',
	'LearningSubject.update',
	'LearningSubject.view',
	'LearningSubject.viewAll',
	'LearningType.archive',
	'LearningType.create',
	'LearningType.update',
	'LearningType.view',
	'LearningType.viewAll',
	'McpRemote.manageMcpRemote',
	'Meeting.cancel',
	'Meeting.create',
	'Meeting.meetingSeriesForProcessing',
	'Meeting.processMeetingSeries',
	'Meeting.restore',
	'Meeting.update',
	'Meeting.updateMeetingAttendeeProposal',
	'Meeting.updateMeetingAttendeeStatuses',
	'Meeting.updateMeetingSeriesAttendeeStatuses',
	'MfaUserConfiguration.associateTotpToken',
	'MfaUserConfiguration.update',
	'MfaUserConfiguration.verifyTotpToken',
	'MfaUserConfiguration.view',
	'MicrosoftConfig.update',
	'MomentInstance.attach',
	'MomentInstance.complete',
	'MomentInstance.reminder',
	'MomentInstance.skip',
	'MomentInstance.view',
	'MomentInstance.viewUser',
	'Note.archive',
	'Note.comment',
	'Note.create',
	'Note.linkEntityToNote',
	'Note.mutualNoteCollaborators',
	'Note.noteSubjectsWithCount',
	'Note.restore',
	'Note.share',
	'Note.unshare',
	'Note.update',
	'Note.view',
	'NoteTemplate.archive',
	'NoteTemplate.create',
	'NoteTemplate.update',
	'NoteTemplate.viewAll',
	'NoteTemplateCategory.archive',
	'NoteTemplateCategory.create',
	'NoteTemplateCategory.viewAll',
	'Notification.mark',
	'Notification.view',
	'NotificationTemplate.updateAll',
	'NotificationTemplate.viewAll',
	'Page.page',
	'Page.update',
	'PersonalAccessToken.managePersonalAccessTokens',
	'PromptInstruction.setOwnWorkspace',
	'PromptInstruction.viewOwnWorkspace',
	'Role.assign',
	'Role.revoke',
	'Role.roles',
	'Search.searchKey',
	'SentEmail.removeSuppressed',
	'SentEmail.viewAll',
	'SentEmail.viewSuppressed',
	'ServiceProvider.view',
	'SharedFeedback.revoke',
	'SharedFeedback.viewAllSharedWith',
	'SlackConfig.update',
	'TalentReview.archive',
	'TalentReview.attachToMoment',
	'TalentReview.create',
	'TalentReview.manage',
	'TalentReview.restore',
	'TalentReview.share',
	'TalentReview.unshare',
	'TalentReview.update',
	'TalentReview.view',
	'TalentReview.viewAll',
	'TalentReviewSnapshot.archive',
	'TalentReviewSnapshot.correct',
	'TalentReviewSnapshot.create',
	'TalentReviewSnapshot.update',
	'TalentReviewSnapshot.view',
	'TalentReviewTemplate.archive',
	'TalentReviewTemplate.create',
	'TalentReviewTemplate.restore',
	'TalentReviewTemplate.update',
	'TalentReviewTemplate.view',
	'TalentReviewTemplate.viewAll',
	'Task.createTask',
	'Task.delete',
	'Task.update',
	'Task.view',
	'User.archive',
	'User.associateAutoSelectedIdentity',
	'User.changeActivatedAt',
	'User.changeExcludeAnalytics',
	'User.count',
	'User.create',
	'User.restore',
	'User.update',
	'User.updateAvatar',
	'User.updateCover',
	'User.updateLocale',
	'User.updateMission',
	'User.updatePrivacyConsent',
	'User.view',
	'User.viewAccountDetails',
	'User.viewAll',
	'User.viewer',
	'User.viewExternalReference',
	'User.viewJourney',
	'User.viewUsersReadyForRedact',
	'UserDocumentV2.create',
	'UserDocumentV2.delete',
	'UserDocumentV2.finalizeUpload',
	'UserDocumentV2.refreshScanStatus',
	'UserDocumentV2.view',
	'UserDocumentV2.viewAll',
	'UserDownload.delete',
	'UserDownload.view',
	'UserDownload.viewAll',
	'UserExport.export',
	'UserNotificationSetting.notificationCustomization',
	'UserNotificationSetting.update',
	'UserRole.assumeWorkspaceRole',
	'UserRole.viewAll',
	'Verification.sendTemporaryPassword',
	'Workspace.update',
	'Workspace.view',
	'WorkspaceFeature.approveFeatureForViewer',
	'WorkspaceFeature.approveForWorkspace',
	'WorkspaceFeature.revokeFeatureApprovalForViewer',
	'WorkspaceFeature.update',
	'WorkspaceMfaSettings.update',
	'WorkspaceMfaSettings.view',
	'WorkspacePlan.enableAi',
	'WorkspaceSSOSettings.update',
	'WorkspaceSSOSettings.view',
	'WorkspaceTheme.update',
];
